// src/pages/CampaignFlow/index.jsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import TopPageHeader from '../../ui/PageHeader';
import FlowStepper from './components/FlowStepper';
import Phase1Profile from './phases/Phase1Profile';
import Phase2Creation from './phases/Phase2Creation';
import Phase3Plans from './phases/Phase3Plans';
import Phase4Dashboard from './phases/Phase4Dashboard';
import './flow.css';

export default function CampaignFlowPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Estado persistido na sessão
  const [step, setStep]               = useState(searchParams.get('step') || 'profile');
  const [campaignId, setCampaignId]   = useState(searchParams.get('campaign') || null);
  const [campaignName, setCampaignName] = useState('');
  const [objective, setObjective]     = useState('');

  // Mantém URL sincronizada com o step atual
  useEffect(() => {
    const params = new URLSearchParams();
    params.set('step', step);
    if (campaignId) params.set('campaign', campaignId);
    navigate(`/campaign-flow?${params.toString()}`, { replace: true });
  }, [step, campaignId]); // eslint-disable-line

  const handlePhase1 = (data) => {
    setCampaignId(data.campaignId);
    setCampaignName(data.campaignName);
    setObjective(data.objective);
    setStep('creation');
  };

  const handlePhase2 = () => {
    setStep('boost');
  };

  const handlePhase3 = () => {
    setStep('sales');
  };

  return (
    <div className="cf-page">
      <TopPageHeader />

      {/* Splash animado */}
      {step === 'profile' && !campaignId && (
        <div className="cf-splash-banner">
          <span className="cf-splash-banner__text">Aumentar suas vendas com IA</span>
        </div>
      )}

      {/* Stepper fixo */}
      <div className="cf-stepper-wrapper">
        <FlowStepper currentStep={step} />
      </div>

      {/* Corpo do fluxo */}
      <div className="cf-body">
        <div className="cf-container">

          {step === 'profile' && (
            <Phase1Profile onNext={handlePhase1} />
          )}

          {step === 'creation' && campaignId && (
            <Phase2Creation
              campaignId={campaignId}
              campaignName={campaignName}
              objective={objective}
              onNext={handlePhase2}
            />
          )}

          {step === 'boost' && campaignId && (
            <Phase3Plans campaignId={campaignId} onNext={handlePhase3} />
          )}

          {step === 'sales' && campaignId && (
            <Phase4Dashboard campaignId={campaignId} />
          )}

          {/* Guard: se step inválido, volta para profile */}
          {!['profile', 'creation', 'boost', 'sales'].includes(step) && (
            <button className="cf-btn cf-btn--ghost" onClick={() => setStep('profile')}>
              ← Voltar ao início
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
